export const DROPDOWN_RESULTS_LENGTH = 5;
export const DEFAULT_PER_PAGE = 15;
export const SEARCH_FIELD_ID = 'search-field';
